// extracted by mini-css-extract-plugin
export default {"menu":"menu___NrL8M","right":"right___BXNQ7","action":"action___L1fEU","search":"search___alPKf","account":"account___f9cVu","avatar":"avatar___pWdO_","dark":"dark___fAGxT"};